import { useEffect, useState } from "react";
export default (service) => {
    const [props, setProps] = useState(null);
    const onUpdate = () => setProps(Object.assign({}, service.props));
    useEffect(() => {
        service.subscribe(onUpdate);
        return () => service.unsubscribe(onUpdate);
    }, []);
    return [props, setProps];
};
//# sourceMappingURL=useServiceProps.js.map